import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const faqs = [
  {
    q: "Sakarya'ya gitmek için en iyi zaman hangisi?",
    a: "Sakarya'yı ziyaret etmek için en ideal dönemler Nisan–Haziran ve Eylül–Kasım aylarıdır. İlkbaharda Sapanca Gölü çevresi ve Acarlar Longozu çiçek açar, sonbaharda ise ormanlar rengarenk bir görünüm kazanır. Yaz aylarında Sapanca Gölü kıyıları ve kamp alanları oldukça kalabalık olabilir; hafta içi tercih etmenizi öneririz.",
  },
  {
    q: "Sakarya'da mutlaka görülmesi gereken yerler hangileri?",
    a: "Sapanca Gölü ve çevresi, Acarlar Longozu (Türkiye'nin en büyük su ormanı), Taraklı Osmanlı evleri, Maşukiye yaylaları, Kırkpınar Şelalesi, Karasu sahili ve Geyve Boğazı Sakarya'nın mutlaka görülmesi gereken yerleri arasındadır. Taraklı, UNESCO Dünya Mirası Geçici Listesi'nde yer alan tarihi bir ilçedir.",
  },
  {
    q: "Acarlar Longozu nedir ve nasıl gidilir?",
    a: "Acarlar Longozu, Türkiye'nin en büyük su ormanı olup Sakarya'nın Kaynarca ilçesine bağlıdır. Nilüfer çiçekleri ve su altında kalan ağaçlarıyla eşsiz bir doğa harikasıdır. Sakarya şehir merkezinden yaklaşık 60 km uzaklıktadır. Tekne turlarıyla gezilir; Mayıs–Temmuz aylarında nilüfer çiçekleri açar ve en güzel dönemdir.",
  },
  {
    q: "Taraklı nasıl bir yer ve neden ziyaret edilmeli?",
    a: "Taraklı, Sakarya'ya bağlı küçük bir ilçe olup Osmanlı döneminden kalma ahşap konak evleriyle ünlüdür. Dar taş sokakları, tarihi çeşmeleri ve geleneksel mimarisiyle zaman yolculuğu hissi yaşatır. Taraklı hamamı (1789) ve Yunus Paşa Camii mutlaka görülmeli. Hafta sonu kaçamağı için İstanbul'a sadece 2 saat uzaklıktadır.",
  },
  {
    q: "Sapanca Gölü'nde ne yapılabilir?",
    a: "Sapanca Gölü çevresinde bisiklet turu, yürüyüş, kano ve kayak gibi su sporları yapılabilir. Gölün kuzey kıyısındaki Maşukiye bölgesinde çok sayıda kafe ve restoran bulunmaktadır. Gölün güneyindeki Sapanca ilçesinde ise balık restoranları ve piknik alanları mevcuttur. Sabah saatlerinde gölün üzerindeki sis manzarası büyüleyicidir.",
  },
  {
    q: "Sakarya'ya İstanbul'dan nasıl gidilir?",
    a: "İstanbul'dan Sakarya'ya ulaşmak için TEM otoyolu üzerinden araçla yaklaşık 1,5–2 saat sürer. Otobüs seferleri İstanbul Büyük Otogarı'ndan düzenli olarak kalkar ve yaklaşık 2 saat sürer. Marmaray ve banliyö treni ile de Adapazarı'na ulaşmak mümkündür; bu seçenek özellikle hafta sonları tercih edilir.",
  },
  {
    q: "Sakarya'da kamp yapılabilecek yerler var mı?",
    a: "Evet, Sakarya kamp tutkunları için harika seçenekler sunar. Sapanca Gölü kıyısındaki kamp alanları, Maşukiye'deki bungalov ve kamp tesisleri, Karasu sahilindeki kamp alanları ve Acarlar çevresindeki doğa kampları en popüler seçenekler arasındadır. Çoğu kamp alanı Nisan–Ekim döneminde hizmet vermektedir.",
  },
  {
    q: "Sakarya'da ne yenilmeli?",
    a: "Sakarya mutfağında öne çıkan lezzetler: Adapazarı ıslama köftesi (Türkiye'nin en ünlü köftelerinden biri), Sapanca balık restoranlarında taze göl balığı, Maşukiye'de kahvaltı ve ev yapımı reçeller, Taraklı'da geleneksel Osmanlı mutfağı ve Karasu'da taze deniz ürünleridir. Adapazarı ıslama köftesi için şehir merkezindeki tarihi köftecileri ziyaret edin.",
  },
  {
    q: "Maşukiye nerede ve ne zaman gidilmeli?",
    a: "Maşukiye, Sapanca Gölü'nün kuzeyinde yer alan ve doğal güzellikleriyle ünlü bir beldedir. Şelaleleri, orman yürüyüş parkurları ve ahşap kafeleriyle özellikle hafta sonları yoğun ilgi görür. İlkbahar ve sonbahar en güzel dönemlerdir. Hafta içi gitmek daha sakin bir deneyim sunar. İstanbul'dan yaklaşık 1,5 saat uzaklıktadır.",
  },
  {
    q: "Sakarya'da kaç gün geçirmek gerekir?",
    a: "Sakarya'nın öne çıkan noktalarını görmek için 2–3 gün yeterlidir. İlk gün Sapanca Gölü ve Maşukiye, ikinci gün Taraklı ve Geyve Boğazı, üçüncü gün ise Acarlar Longozu ve Karasu sahili için idealdir. Kocaeli ile birleştirirseniz 4–5 günlük kapsamlı bir Marmara doğa turu yapabilirsiniz.",
  },
  {
    q: "Sakarya'da hangi doğa aktiviteleri yapılabilir?",
    a: "Sakarya'da yapılabilecek doğa aktiviteleri: Sapanca Gölü'nde kano ve kayak, Maşukiye'de şelale yürüyüşleri, Acarlar Longozu'nda tekne turu, Karasu sahilinde sörf ve yüzme, Taraklı çevresinde bisiklet turu ve Geyve Boğazı'nda rafting (mevsimlik). Bölge, İstanbul'a yakınlığı nedeniyle hafta sonu kaçamağı için idealdir.",
  },
  {
    q: "Sakarya'da konaklama seçenekleri nelerdir?",
    a: "Sakarya'da konaklama için Sapanca Gölü kıyısındaki butik oteller ve bungalovlar, Maşukiye'deki doğa evleri, Taraklı'daki tarihi konak pansiyonları ve Adapazarı şehir merkezindeki oteller tercih edilebilir. Sapanca Gölü manzaralı butik oteller özellikle çiftler için romantik bir seçenektir.",
  },
];

const SakarayaFaq = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  useEffect(() => {
    const title = "Sakarya Seyahat SSS — Sapanca Gölü, Taraklı ve Acarlar Longozu Rehberi 2026";
    const desc = "Sakarya'ya seyahat planlayanlar için en sık sorulan sorular: Sapanca Gölü, Acarlar Longozu, Taraklı, Maşukiye ve ulaşım hakkında kapsamlı rehber.";
    document.title = title;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? "property" : "name";
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) { el = document.createElement("meta"); el.setAttribute(attr, name); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    const setCanonical = (url: string) => {
      let el = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
      if (!el) { el = document.createElement("link"); el.setAttribute("rel", "canonical"); document.head.appendChild(el); }
      el.setAttribute("href", url);
    };
    const injectSchema = (id: string, data: object) => {
      let el = document.getElementById(id);
      if (!el) { el = document.createElement("script"); el.id = id; el.setAttribute("type", "application/ld+json"); document.head.appendChild(el); }
      el.textContent = JSON.stringify(data);
    };

    setCanonical("https://geziturkiyem.com/sakarya-sss");
    setMeta("description", desc);
    setMeta("keywords", "sakarya seyahat, sapanca gölü, acarlar longozu, taraklı gezilecek yerler, sakarya sss, maşukiye rehberi, adapazarı ıslama köftesi, sakarya kamp alanları, sapanca bungalov, taraklı osmanlı evleri, sakarya doğa yürüyüşü, karasu sahili, geyve boğazı, sakarya hafta sonu kaçamak, sapanca gölü bisiklet, maşukiye şelale, sakarya konaklama, adapazarı gezilecek yerler, sakarya ilkbahar, sapanca kano, acarlar nilüfer çiçeği, taraklı hamam, sakarya istanbul yakını, marmara doğa turu, sakarya ne zaman gidilir, sapanca balık restoranı, sakarya kış, sakarya yaz, sakarya sonbahar, sakarya ulaşım, sakarya otobüs, sakarya marmaray");
    setMeta("geo.placename", "Sakarya");
    setMeta("geo.region", "TR-54");
    setMeta("og:title", title, true);
    setMeta("og:description", desc, true);
    setMeta("og:type", "article", true);
    setMeta("og:url", "https://geziturkiyem.com/sakarya-sss", true);
    setMeta("og:image", "https://readdy.ai/api/search-image?query=Sapanca%20lake%20Turkey%20morning%20mist%20reflection%20green%20forest%20mountains%20peaceful%20serene%20nature&width=1200&height=630&seq=sak-sss-og&orientation=landscape", true);
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", title);
    setMeta("twitter:description", desc);

    injectSchema("schema-sakarya-faq", {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqs.map((f) => ({
        "@type": "Question",
        "name": f.q,
        "acceptedAnswer": { "@type": "Answer", "text": f.a },
      })),
    });

    injectSchema("schema-sakarya-breadcrumb", {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        { "@type": "ListItem", "position": 1, "name": "Ana Sayfa", "item": "https://geziturkiyem.com/" },
        { "@type": "ListItem", "position": 2, "name": "Sakarya SSS", "item": "https://geziturkiyem.com/sakarya-sss" },
      ],
    });

    return () => {
      document.title = "Türkiye Seyahat Rehberi";
      document.getElementById("schema-sakarya-faq")?.remove();
      document.getElementById("schema-sakarya-breadcrumb")?.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero */}
      <div className="relative pt-20 pb-16 overflow-hidden bg-stone-900">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Sapanca%20lake%20Turkey%20lush%20green%20forest%20mountains%20misty%20morning%20calm%20water%20reflection%20wide%20panoramic%20landscape&width=1400&height=500&seq=sak-sss-hero&orientation=landscape"
            alt="Sakarya Sapanca Gölü"
            className="w-full h-full object-cover object-top opacity-30"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>
        </div>
        <div className="relative max-w-3xl mx-auto px-4 md:px-8 text-center">
          <nav className="flex items-center justify-center gap-2 text-xs text-stone-400 mb-5">
            <Link to="/" className="hover:text-white transition-colors">Ana Sayfa</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-white">Sakarya SSS</span>
          </nav>
          <span className="inline-block bg-amber-500/20 border border-amber-400/30 text-amber-300 text-xs font-semibold px-4 py-1.5 rounded-full mb-4 uppercase tracking-widest">
            Sık Sorulan Sorular
          </span>
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
            Sakarya Seyahat Rehberi
          </h1>
          <p className="text-stone-300 text-sm max-w-xl mx-auto">
            Sakarya'ya seyahat planlayanların en çok merak ettiği sorular ve kapsamlı cevapları.
          </p>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-4 md:px-8 py-14">
        {/* Intro */}
        <div className="bg-amber-50 border border-amber-100 rounded-2xl p-6 mb-10">
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 flex items-center justify-center bg-amber-100 rounded-xl flex-shrink-0">
              <i className="ri-water-flash-line text-amber-600 text-xl"></i>
            </div>
            <div>
              <h2 className="font-bold text-stone-900 mb-1" style={{ fontFamily: "'Playfair Display', serif" }}>
                Sakarya Hakkında
              </h2>
              <p className="text-stone-600 text-sm leading-relaxed">
                Marmara Bölgesi'nde yer alan Sakarya, Sapanca Gölü'nün berrak suları, Acarlar Longozu'nun mistik su ormanı ve Taraklı'nın tarihi Osmanlı dokusuyla İstanbul'a yakın en güzel kaçamak destinasyonlarından biridir. Aşağıda Sakarya seyahati hakkında en sık sorulan soruları ve cevaplarını bulabilirsiniz.
              </p>
            </div>
          </div>
        </div>

        {/* FAQ Accordion */}
        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className={`border rounded-2xl overflow-hidden transition-all duration-200 ${
                openIndex === i ? "border-amber-300 bg-amber-50/50" : "border-stone-100 bg-white hover:border-stone-200"
              }`}
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer"
              >
                <h4 className={`font-semibold text-sm leading-snug pr-4 ${openIndex === i ? "text-amber-800" : "text-stone-900"}`}>
                  <a id={`sss-${i + 1}`} className="scroll-mt-20">{faq.q}</a>
                </h4>
                <div className={`w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 transition-all ${
                  openIndex === i ? "bg-amber-500 text-white rotate-180" : "bg-stone-100 text-stone-500"
                }`}>
                  <i className="ri-arrow-down-s-line text-sm"></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-6 pb-5">
                  <p className="text-stone-600 text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Related Links */}
        <div className="mt-14 grid grid-cols-1 sm:grid-cols-3 gap-4">
          <Link to="/kocaeli-sss" className="group flex flex-col gap-2 p-5 bg-stone-50 border border-stone-100 rounded-2xl hover:border-amber-200 transition-all">
            <div className="w-8 h-8 flex items-center justify-center bg-stone-200 group-hover:bg-amber-100 rounded-xl transition-colors">
              <i className="ri-landscape-line text-stone-600 group-hover:text-amber-600 text-sm"></i>
            </div>
            <p className="font-semibold text-stone-900 text-sm">Kocaeli SSS</p>
            <p className="text-xs text-stone-400">Kartepe ve Sapanca rehberi</p>
          </Link>
          <Link to="/bolu-sss" className="group flex flex-col gap-2 p-5 bg-stone-50 border border-stone-100 rounded-2xl hover:border-amber-200 transition-all">
            <div className="w-8 h-8 flex items-center justify-center bg-stone-200 group-hover:bg-amber-100 rounded-xl transition-colors">
              <i className="ri-tree-line text-stone-600 group-hover:text-amber-600 text-sm"></i>
            </div>
            <p className="font-semibold text-stone-900 text-sm">Bolu SSS</p>
            <p className="text-xs text-stone-400">Abant ve Yedigöller rehberi</p>
          </Link>
          <Link to="/istanbul-sss" className="group flex flex-col gap-2 p-5 bg-stone-50 border border-stone-100 rounded-2xl hover:border-amber-200 transition-all">
            <div className="w-8 h-8 flex items-center justify-center bg-stone-200 group-hover:bg-amber-100 rounded-xl transition-colors">
              <i className="ri-building-line text-stone-600 group-hover:text-amber-600 text-sm"></i>
            </div>
            <p className="font-semibold text-stone-900 text-sm">İstanbul SSS</p>
            <p className="text-xs text-stone-400">Boğaz ve tarihi yarımada rehberi</p>
          </Link>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default SakarayaFaq;
